function promoImgBlockPosition(){
    if ($('.info-banner').length){
        let banner = $('.info-banner'),
            promo = $('.promo--home'),
            promoTouch = $('.promo__home-background-wrap'),
            header = $('.main-header'),
            wS = $(window).scrollTop();
        if ($('.no-touchevents').length) {

            if (wS < header.outerHeight() + banner.outerHeight()) {
                promo.css(
                    'background-position', 'center ' + (banner.outerHeight() - wS) + 'px'
                );
            }
            else {
                promo.css(
                    'background-position', 'center 0'
                );
            }

        }
        else if (!$('.no-touchevents').length) {

            if (wS < header.outerHeight() + banner.outerHeight()) {
                promoTouch.css(
                    'top', (banner.outerHeight() - wS) + 'px'
                )
            }
            else {
                promoTouch.css(
                    'top', '0'
                )
            }

        }
    }

}

$(window).on('load scroll resize orientationchange', function(){
    promoImgBlockPosition();
});